import React from "react"
import { Row, Col, Tabs, Space } from "antd"
import StatCard from "../components/StatCard"
import QuickActions from "../components/QuickActions"
import NotificationPanel from "../components/NotificationPanel"
import BankTransactions from "../components/BankTransactions"
import {
  ProjectOutlined,
  CheckCircleOutlined,
  ClockCircleOutlined,
  FileAddOutlined,
  AppstoreOutlined,
  FolderOutlined,
  BarChartOutlined,
  BankOutlined,
} from "@ant-design/icons"

const ExecutorDashboard = ({
  infoMessage,
  telegramLink,
  userInfo,
}) => {
  // Mock stats - replace with actual data from props
  const stats = [
    {
      title: "پرونده‌های ثبت شده",
      value: 45,
      icon: <ProjectOutlined />,
      trend: "up",
      trendValue: "+5 این هفته",
    },
    {
      title: "در انتظار تایید",
      value: 12,
      icon: <ClockCircleOutlined />,
      suffix: "مورد",
    },
    {
      title: "تایید شده",
      value: 289,
      icon: <CheckCircleOutlined />,
      trend: "up",
      trendValue: "این ماه: 18 مورد",
    },
    {
      title: "نیاز به اصلاح",
      value: 3,
      icon: <FileAddOutlined />,
    },
  ]

  // Tab items using modern Ant Design API
  const tabItems = [
    {
      key: "1",
      label: (
        <Space>
          <AppstoreOutlined />
          نمای کلی
        </Space>
      ),
      children: (
        <Row gutter={[16, 16]}>
          <Col xs={24} lg={8}>
            <QuickActions role="Executor" />
          </Col>
          <Col xs={24} lg={16}>
            <NotificationPanel
              telegramLink={telegramLink}
              showTelegram={true}
              maxItems={5}
            />
          </Col>
        </Row>
      ),
    },
    {
      key: "2",
      label: (
        <Space>
          <BankOutlined />
          تراکنش‌های بانکی
        </Space>
      ),
      children: <BankTransactions />,
    },
    {
      key: "3",
      label: (
        <Space>
          <FolderOutlined />
          پرونده‌های من
        </Space>
      ),
      children: (
        <Row gutter={[16, 16]}>
          <Col xs={24}>
            <StatCard
              title="لیست پرونده‌های من"
              value="به زودی"
              icon={<ProjectOutlined />}
            />
          </Col>
        </Row>
      ),
    },
    {
      key: "4",
      label: (
        <Space>
          <ClockCircleOutlined />
          در انتظار بررسی
        </Space>
      ),
      children: (
        <Row gutter={[16, 16]}>
          <Col xs={24}>
            <StatCard
              title="پرونده‌های در انتظار بررسی"
              value="به زودی"
              icon={<ClockCircleOutlined />}
            />
          </Col>
        </Row>
      ),
    },
    {
      key: "5",
      label: (
        <Space>
          <BarChartOutlined />
          آمار عملکرد
        </Space>
      ),
      children: (
        <Row gutter={[16, 16]}>
          <Col xs={24} md={12}>
            <StatCard
              title="میانگین زمان ثبت"
              value={2.5}
              suffix="روز"
              icon={<FileAddOutlined />}
            />
          </Col>
          <Col xs={24} md={12}>
            <StatCard
              title="نرخ تایید"
              value={91}
              suffix="%"
              icon={<CheckCircleOutlined />}
              trend="up"
            />
          </Col>
        </Row>
      ),
    },
  ]

  return (
    <Space direction="vertical" size="large" style={{ width: "100%" }}>
      {/* Statistics Cards */}
      <Row gutter={[16, 16]}>
        {stats.map((stat, index) => (
          <Col xs={24} sm={12} lg={6} key={index}>
            <StatCard {...stat} />
          </Col>
        ))}
      </Row>

      {/* Main Content */}
      <Tabs
        defaultActiveKey="1"
        size="large"
        type="card"
        items={tabItems}
        destroyInactiveTabPane={true}
      />
    </Space>
  )
}

export default ExecutorDashboard
